import { render, staticRenderFns } from "./TeacherIndividualLeaveAssignmentPage.vue?vue&type=template&id=35f313d7&scoped=true&"
import script from "./TeacherIndividualLeaveAssignmentPage.vue?vue&type=script&lang=js&"
export * from "./TeacherIndividualLeaveAssignmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f313d7",
  null
  
)

export default component.exports